import Client from '../client';
import { AxiosResponse } from 'axios';
 
const LogService = 
{
    obterLog(idJornada: string, tipoLog: string): Promise<void | AxiosResponse<any>> 
    {
        return Client.getZip('logs?idJornada='+ idJornada + '&tipoLog=' + tipoLog);
    }
}

export default LogService;